exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nul[data-v-d0fc3bc8] {\r\n  list-style: disc;\r\n  padding-left: 25px;\r\n  padding-top: 10px;\n}\nul.simple[data-v-d0fc3bc8] {\r\n  list-style: none;\n}\n.title[data-v-d0fc3bc8]{\r\n  font-weight: 600;\n}\n.uppercase[data-v-d0fc3bc8]{\r\n  text-transform: uppercase;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-d0fc3bc8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/privacy-policy.vue
// module id = 650
// module chunks = 0